import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BoobleModalService } from 'booble-modal';
import { ContactModal } from '../../modals/contact/contact-modal.component';
import { PrivacyPolicyModal } from '../../modals/privacy-policy/privacy-policy-modal.component';
import { UseTermsModal } from '../../modals/use-terms/use-terms-modal.component';
import { FooterLayoutComponent } from '../footer-layout/footer-layout.component';
import { ActivatedRoute } from '@angular/router';
import { TenantGeneralService } from 'src/app/core/tenant-general.service';
import { TextsService } from 'src/app/core/texts.service';

@Component({
  selector: 'app-register-layout',
  templateUrl: './register-layout.component.html',
  styleUrls: ['./register-layout.component.scss'],
})
export class RegisterLayoutComponent implements OnInit {
  tenant: string = '';
  personType: string = '';

  constructor(
    private readonly modalService: BoobleModalService,
    private readonly route: ActivatedRoute,
    public tenantService: TenantGeneralService,
    private readonly textsService: TextsService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const tenant = params.get('tenant');
      if (tenant) this.tenant = params.get('tenant');
      const personType = params.get('personType');
      if (personType) this.personType = params.get('personType');
    });
  }

  openTermsModal() {
    this.modalService.present(UseTermsModal);
  }

  openPrivacyPolicyModal() {
    this.modalService.present(PrivacyPolicyModal);
  }
  getWelcomeText(): string {
    return this.textsService.getText('welcome', this.tenant);
  }

  openContactModal() {
    this.modalService.present(ContactModal);
  }
}
